import { cardSrc } from './resultParsers';

// Andar Bahar result — production admin: simple inline-block card list (NO hooper
// carousel). detail.card interleaved (bahar even idx, andar odd idx). Order natural
// (aall/ball order). Wrapper class `ab20-result` (CSS: .ab20-result .casino-result-cards-item img).
export default function AB20Result({ detail }) {
  const allCards = (detail?.card || '').split(',').map((c) => c.trim()).filter(Boolean);
  const andar = allCards.filter((_, i) => i % 2 === 1);
  const bahar = allCards.filter((_, i) => i % 2 === 0);

  const cardList = (cards) => (
    <div className="text-center">
      {cards.map((code, i) => (
        <div key={i} className="casino-result-cards-item item">
          <img src={cardSrc(code)} alt={code} />
        </div>
      ))}
    </div>
  );

  return (
    <div className="row row5 ab20-result">
      <div className="col-12">
        <h5 className="text-center">Andar</h5>
        {cardList(andar)}
      </div>
      <div className="col-12 mt-2">
        <h5 className="text-center">Bahar</h5>
        {cardList(bahar)}
      </div>
    </div>
  );
}
